import CONQUER from "../CONQUER";
import { ACTIONS } from '../../Models/ENUM';

class Share
{
    private conquer : CONQUER;

    constructor( conquer:CONQUER )
    {
        this.conquer = conquer;
    }

    public async get( params:any )
    {
        return await this.conquer.do( ACTIONS.SHARE_GET, params );
    }

    public async getOne( params:any )
    {
        return await this.conquer.do( ACTIONS.SHARE_GETONE, params );
    }

    public async set( params:any )
    {
        return await this.conquer.do( ACTIONS.SHARE_GET, params );
    }

    // OLD CODE NOW:

    public share( title: string, text: string, url: string, bitmapData:string )
    {
        if ( typeof window == 'undefined') return;

        if (this.conquer.currentPlatform != 'Android' && this.conquer.currentPlatform != 'iOS') 
        {
            if (typeof (window as any).share == 'undefined') {
                return Promise.resolve({
                    result:false, 
                    error:new Error(`[share] ${this.conquer.currentPlatform} is not implemented`)
                });
            } 
            (window as any).share(`${title} - ${text}`, url, bitmapData);
            return Promise.resolve({ result: true });
        } 

        //@ts-expect-error
        if (this.conquer.currentPlatform == 'Web')
        {
            navigator.share({
                'title': title,
                'text': text,
                'url': url
            }).then(() => {
                console.log('Successful share');
            }).catch((error) => {
                console.log('Error sharing:', error)
            });
        }

    }

    public whatsApp( title: string, text: string, url: string )
    {
        if ( typeof window == 'undefined') return;

        title   = title.length > 0 ? `*${title}* ` : ``;
        text    = text.length > 0 ? `${text} ` : ``;
        url     = url.length > 0 ? `_${url}_ ` : ``;
        let message:string  = `${title}${text}${url}`;

        window.open(`https://api.whatsapp.com/send/?&text=${message}&type=phone_number&app_absent=0`);
    };

    public contactsGet()
    {
        if ( typeof window == 'undefined') return;

        var onSuccess = (contacts:any[]) => {
            console.log('Found ' + contacts.length + ' contacts.');
        };
    
        var onError = (contactError:Error) => {
            console.log('onError!');
        };
        var cordovaNavigator:any = navigator;
        var fields       = [cordovaNavigator.contacts.fieldType.displayName, cordovaNavigator.contacts.fieldType.name];
        
        cordovaNavigator.contacts.find(fields, onSuccess, onError);
    
    };
    
}

export default Share;